import { render, staticRenderFns } from "./ChemUofA103SandboxQ2_1.vue?vue&type=template&id=2ac683da&"
import script from "./ChemUofA103SandboxQ2_1.vue?vue&type=script&lang=js&"
export * from "./ChemUofA103SandboxQ2_1.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VForm } from 'vuetify/lib/components/VForm';
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VForm,VImg})
